const COUNTRIES = ['ca']

const countrySettings = COUNTRIES.reduce((obj, file) => {
  const country = require(`./countries/${file}`)
  obj[country.code] = country
  return obj
}, {})

module.exports = Object.freeze(countrySettings)
